import { render } from "./ListeInfoFooter.vue?vue&type=template&id=18b9cef0&ts=true"
import script from "./ListeInfoFooter.vue?vue&type=script&lang=ts"
export * from "./ListeInfoFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__